import formatTime from './formatTime';

export default formatTime;
